import { Card, CardContent } from '@/components/ui/card'
import type { LucideIcon } from 'lucide-react'

interface MetricCardProps {
  label: string
  value: string | number
  icon: LucideIcon
}

export function MetricCard({ label, value, icon: Icon }: MetricCardProps) {
  return (
    <Card
      className="border border-gray-300 dark:border-gray-700"
      style={{ backgroundImage: 'linear-gradient(to right, rgba(20,184,166,0.15), rgba(20,184,166,0.05) 50%, transparent)' }}
    >
      <CardContent className="p-4 flex items-center gap-4">
        <Icon className="h-5 w-5 text-teal-500" />
        <div>
          <p className="text-sm text-muted-foreground">{label}</p>
          <p className="text-2xl font-bold text-black dark:text-white">{value}</p>
        </div>
      </CardContent>
    </Card>
  )
}
